/**
 * Fusionne une valeur API Strapi avec un fallback (string / richtext).
 * Utile pour toutes les pages CMS.
 */

export function pickCmsText(value, fallback) {
  if (value == null) return fallback;
  const s = String(value).trim();
  return s.length > 0 ? value : fallback;
}

export function pickCmsTitle(value, fallback) {
  return pickCmsText(value, fallback);
}
